import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';

const muiButton: {
  defaultProps?: ComponentsProps['MuiButton'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiButton'];
  variants?: ComponentsVariants['MuiButton'];
} = {
  styleOverrides: {
    root: {
      textTransform: 'none',
    },
    contained: {
      minWidth: 182,
      textTransform: 'none',
      padding: '.545rem 2rem',
      borderRadius: '.5rem',
    },
    sizeSmall: {
      padding: '4px 10px',
      fontSize: '0.8125rem',
    },
  },
};

export default muiButton;
